export const buttonFunctionalityClasses = {
  ENABLE: 'text-purple cursor-pointer fill-purple',
  DISABLE: 'text-gray cursor-not-allowed fill-gray',
};
